import { render } from "./td.vue?vue&type=template&id=a1e4b5ac&scoped=true"
import script from "./td.vue?vue&type=script&lang=js"
export * from "./td.vue?vue&type=script&lang=js"

import "./td.vue?vue&type=style&index=0&id=a1e4b5ac&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e4b5ac"]])

export default __exports__